import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ExpenseApprovalItem {
  id: string;
  code: string;
  targetType: 'BOOKING' | 'TOUR' | 'GENERAL';
  tourDetails: {
    tourNo: string;
    tourCode: string;
    tourName: string;
    country: string;
    travelDate: string | null;
    returnDate: string | null;
    requiredPax: number | null;
    tourTotalAmount: number | string;
  } | null;
  bookingCode: string;
  customerName: string;
  tripName: string;
  travelDate: string | null;
  travelerCount: number;
  bookingTotal: number | string;
  title: string;
  requester: string;
  department: string;
  expenseNameSnapshot: string;
  paymentAccountSource: 'REFERENCE_FILE' | 'OTHER_BANK_ACCOUNT' | null;
  bankName: string | null;
  accountNumber: string | null;
  purchaseOrderFileName: string;
  attachmentUrl: string | null;
  amount: number | string;
  status: 'SUPERVISOR_REVIEW';
  submittedAt: string;
}

@Injectable({ providedIn: 'root' })
export class ExpenseApprovalService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/expenses/supervisor-review`;

  async getPending(): Promise<ExpenseApprovalItem[]> {
    const response = await firstValueFrom(
      this.http.get<{ expenses: ExpenseApprovalItem[] }>(this.apiUrl, { withCredentials: true }),
    );
    return response.expenses;
  }

  async approve(id: string): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/approve`, {}, { withCredentials: true }),
    );
  }

  async reject(id: string): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/reject`, {}, { withCredentials: true }),
    );
  }

  resolveFileUrl(fileUrl: string): string {
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    if (/^https?:\/\//i.test(environment.apiUrl)) {
      return `${new URL(environment.apiUrl).origin}${fileUrl}`;
    }
    return fileUrl;
  }
}
